import { useCardImageAspectRatioStore, type WallBoard, type WallCard } from '@walls/store';
import { CardBody } from './CardBody';
import { CardFrame } from './CardFrame';
import { CardOwnerLabel } from './CardOwnerLabel';
import { useCardPermissions } from './hooks/useCardPermissions';
import { useParticipantName } from './hooks/useParticipantName';
import { getCardFrameDimensions } from './utils/cardGeometry';

interface ShapeCardProps {
  board: WallBoard;
  card: WallCard;
  isClusterChild?: boolean;
  measureDependencies?: unknown[];
  rounded?: boolean;
}

export function RectangleCard({
  board,
  card,
  isClusterChild = false,
  measureDependencies = [],
  rounded = false,
}: ShapeCardProps) {
  const imageAspectRatio = useCardImageAspectRatioStore((state) => state.ratios[card.id]);
  const dimensions = getCardFrameDimensions(card, imageAspectRatio);
  const permissions = useCardPermissions(board, card);
  const participantName = useParticipantName(card.ownerId);
  const ownerName = permissions.showOwnerName ? participantName : '';

  return (
    <CardFrame
      board={board}
      card={card}
      isClusterChild={isClusterChild}
      measureDependencies={measureDependencies}
      sx={{
        bgcolor: card.color || '#ffff99',
        borderRadius: rounded ? '10px' : 0,
        minHeight: 38,
        overflow: rounded ? 'hidden' : 'visible',
        width: dimensions.width,
        height: dimensions.height,
      }}
    >
      <CardBody board={board} card={card} />
      <CardOwnerLabel ownerName={ownerName} />
    </CardFrame>
  );
}
